import { createSelector } from "reselect";
import { SkipToken, skipToken } from "@reduxjs/toolkit/query";
import {
  BaseGetTradeExtraInfoDataRequest,
  FixMeLater,
  GetTradeExtraInfoOrdersGraphRequest,
} from "@shared/types";
import { sharedLib } from "@shared/services/shared.service";
import {
  getPriceGraphDataWithActivities,
  getTradeAnnotations,
} from "@shared/features/trades/common/utils";
import { EditOrderData } from "@shared/features/trades/EditTrade/types";

export const selectFormattedTradeExtraInfoOrdersGraphData = (
  args?: GetTradeExtraInfoOrdersGraphRequest | SkipToken,
  activitiesArgs?: BaseGetTradeExtraInfoDataRequest | SkipToken
) =>
  createSelector(
    sharedLib.sharedApi.trades.endpoints.getTradeExtraInfoOrdersGraph.select(
      args ?? skipToken
    ),
    sharedLib.sharedApi.trades.endpoints.getTradeExtraInfoActivities.select(
      activitiesArgs ?? skipToken
    ),
    ({ data }, { data: activitiesData }) => {
      const chartData =
        (args &&
          args !== skipToken &&
          data?.data?.graph_data?.[args.time_range]) ||
        [];
      if (chartData.length === 0) return [];
      const precisionConfig = data?.precision;
      return getPriceGraphDataWithActivities(
        chartData,
        activitiesData,
        precisionConfig
      );
    }
  );

export const selectTradeGraphOrdersAnnotations = (
  ordersArgs: BaseGetTradeExtraInfoDataRequest | SkipToken,
  theme: FixMeLater,
  entryOrders: EditOrderData[] | undefined,
  takeProfitOrders: EditOrderData[] | undefined,
  stopOrders: EditOrderData[] | undefined,
  precision: number
) =>
  createSelector(
    sharedLib.sharedApi.trades.endpoints.getTradeExtraInfoOrders.select(
      ordersArgs
    ),
    ({ data: tradeExtraInfoOrdersResponse }) => {
      if (!tradeExtraInfoOrdersResponse) return [];
      return getTradeAnnotations(
        theme,
        entryOrders,
        takeProfitOrders,
        stopOrders,
        precision,
        true,
        tradeExtraInfoOrdersResponse.data.current_price
      );
    }
  );
